import { VApp } from 'vuetify/lib/components/VApp';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticStyle:{"background-color":"#000000 !important"}},[_c(VMain,{class:{ '': _vm.inApp, 'page-content': _vm.subAppView },staticStyle:{"background":"rgb(0,0,0)"}},[_c(VFadeTransition,{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('snackbar'),_c('win-overlay'),_c('prompt')],1),_c('overlay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }